var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgStopwatch = function SvgStopwatch(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E02020",
    d: "M6.004 0v1.335h1.335v.667c.467-.067.867-.067 1.334 0v-.667h1.335V0H6.004z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E02020",
    d: "M12.545 4.405l.467-.467.534.533.934-.934-2.002-2.002-.934.934.534.534-.6.6c-3.204-1.934-7.342-.933-9.21 2.27C.399 9.076 1.4 13.08 4.537 15.015c3.136 1.936 7.274.935 9.142-2.268 1.669-2.737 1.202-6.207-1.134-8.342zm-4.538 9.543c-2.603 0-4.672-2.069-4.672-4.672 0-2.602 2.07-4.671 4.672-4.671v4.671h4.671c0 2.603-2.068 4.672-4.671 4.672z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStopwatch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stopwatch.e1c54f0c.svg";
export { ForwardRef as ReactComponent };